import { Box, Alert, Grid, Stack, Typography, Divider } from '@mui/material';
import { Logo } from 'ui-component';
import colors from 'assets/scss/_themes-vars.module.scss';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useSettings } from 'hooks/useSettings';

const ErrorFallback = ({ error }) => {
    const { t } = useTranslation();
    const { projectFullTitle, projectLogo } = useSettings();
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                pl: { xs: 2, sm: 4, md: 8, lg: 12 },
                pr: { xs: 2, sm: 4, md: 8, lg: 12 },
                width: '100%',
                borderRadius: 2
            }}
        >
            <Grid container spacing={1} alignItems="center" justifyContent="center" sx={{ background: 'white', p: 2, borderRadius: 2 }}>
                <Grid item xs={12}>
                    <Stack spacing={1} direction="row" justifyContent="space-between" alignItems="center">
                        <Typography variant="h2">{projectFullTitle}</Typography>
                        <Logo logo={projectLogo} link="/" />
                    </Stack>
                </Grid>
                <Grid item xs={12}>
                    <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
                        <Box sx={{ width: '4px', height: 'auto', background: colors?.primaryMain }} />
                        <Typography variant="h2">{t('PaymentPlatform')}</Typography>
                        <Typography variant="h2">{` - `}</Typography>
                        <Typography variant="h2">{t('PaymentRequests')}</Typography>
                    </Stack>
                </Grid>
                <Grid item xs={12} sx={{ mb: 1 }}>
                    <Divider />
                </Grid>
                <Grid item xs={12}>
                    <Alert severity="error" sx={{ cursor: 'pointer', mb: 2 }}>
                        {error?.message}
                    </Alert>
                </Grid>
            </Grid>
        </Box>
    );
};

ErrorFallback.propTypes = {
    error: PropTypes.object
};

export default ErrorFallback;
